<template>
  <div class="contain">
    <div :class="'verify ' + isClass" v-if="!showCountry">
      <div class="head" v-if="true">
        <h2>防伪验证</h2>
        <span class="el-icon-arrow-left" @click="handleBack"></span>
      </div>
      <div class="bananer">
        <img src="../assets/img/verify/bananer1.png" alt />
      </div>
      <div class="tel">
        <div class="tel_num">
          <div class="left" @click="handleSelect">
            <span>+{{ areaCode }}</span>
            <span class="el-icon-caret-bottom"></span>
          </div>
          <div class="right">
            <input
              type="tel"
              class="num"
              v-model="telNum"
              placeholder="请输入手机号"
              maxlength="11"
            />
            <div class="clear" v-show="cancel" @click="handleClickTel">
              <img src="../assets/img/verify/quxiao1.png" alt />
            </div>
          </div>
        </div>
        <div class="tel_code">
          <input
            type="number"
            placeholder="请输入验证码"
            v-model="telCode"
            oninput="if(value.length>6)value=value.slice(0,6)"
            pattern="\d*"
          />
          <div @click="handleCode" v-show="onCodeText" :class="codeColor">
            获取验证码
          </div>
          <div v-show="onCodeNum">{{ sec }}s</div>
        </div>
      </div>
      <div :class="boxName" @click="goLogin">获取证书</div>
      <div class="info">
        <h3>注意事项 :</h3>
        <p>1、每个乐器二维码是唯一标识；</p>
        <p>2、扫描后需绑定维修信息，才可以查询防伪证书；</p>
        <p>3、绑定成功后会赠送相关课程；</p>
        <p>4、重复扫描验证不会再赠送课程。</p>
      </div>
      <!-- <Result v-if="true" /> -->

      <div class="logo">
        <img src="../assets/img/verify/logo1.png" alt />
      </div>
      <Download @setGaodu="setGaodu" />
      <div class="verify_shade" v-if="oftenCode"></div>
      <div class="content" v-if="oftenCode">
        <h3>提示</h3>
        <div class="content_text">
          <p>获取验证码过于频繁</p>
        </div>
        <div class="content_btn" @click="handleClose">关闭</div>
      </div>
      <div class="light_hint" v-if="showHint">
        <span>{{ hintText }}</span>
      </div>
    </div>
    <Country v-if="showCountry" @selectAreaCode="selectAreaCode" />
    <aliCaptcha :origin-request="getcodefun"></aliCaptcha>
  </div>
</template>

<script>
import Download from "@/components/download.vue";
// import Result from "@/components/result.vue";
import Country from "@/components/country.vue";
import aliCaptcha from "@/components/aliCaptcha.vue";
export default {
  data() {
    return {
      telNum: "", //手机号
      telCode: "", //验证码
      cancel: false,
      boxName: "btn",
      areaCode: "86", //地区码
      hintText: "天气不错", //提示文本
      showHint: false, //显示提示文本
      sec: "", //验证码倒计时
      onCodeNum: false, //显示验证码倒计时
      onCodeText: true, //显示验证码文本
      showCountry: false, //显示国家码选择
      originCode: "", //扫码来源
      qrCode: "",
      codeColor: "",
      oftenCode: false,
      preventClick: false,
      isClass: "gaodu", //在页面上控制class
      // screenHeight: document.body.clientHeight,
      // originHeight: document.body.clientHeight, //默认高度在watch里拿来做比较
    };
  },
  watch: {
    telNum() {
      this.telNum.trim() == ""
        ? ((this.cancel = false), (this.codeColor = ""))
        : ((this.cancel = true),
          (this.boxName = "commit"),
          (this.codeColor = "tel_code_text"));
      this.telNum.trim().length >= 6 && this.telCode.trim().length == 6
        ? (this.boxName = "commit")
        : (this.boxName = "btn");
    },
    telCode() {
      this.telNum.trim().length >= 6 && this.telCode.trim().length == 6
        ? (this.boxName = "commit")
        : (this.boxName = "btn");
    },
  },
  mounted() {
    localStorage.removeItem("contoken");
    window.addEventListener("offline", () => {
      this.hintText = "似乎已断开与网络的连接";
      this.showHint = true;
      this.setCountDown();
    });
    this.qrCode = this.$route.query.code;
    this.getOrigin();
  },
  components: {
    Download,
    // Result,
    Country,
    aliCaptcha,
  },
  methods: {
    setGaodu() {
      this.isClass = "";
    },
    // 扫码来源
    getOrigin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
        this.originCode = 1;
      } else {
        this.originCode = 0;
      }
    },
    handleClickTel() {
      this.telNum = "";
    },
    handleSelect() {
      this.showCountry = true;
    },
    selectAreaCode(code) {
      if (code) {
        this.areaCode = code;
      }
      this.showCountry = false;
    },
    // 获取验证码
    handleCode() {
      if (this.preventClick) {
        return;
      }
      this.preventClick = true;
      document.getElementById("captcha-button").click();
    },
    getcodefun(captchaData) {
      return new Promise((rs, rj) => {
        this.$API
          .getVerifyCode({
            area_code: this.areaCode,
            mobile: this.telNum,
            event: "login",
            captcha_verify: captchaData,
          })
          .then((res) => {
            if (res.error_code != 0) {
              if (res.error_code == 18002001) {
                this.oftenCode = true;
              } else {
                this.hintText = res.message;
                this.showHint = true;
                this.setCountDown();
                this.preventClick = false;
              }
              rs(res);
              this.$message.error(res.message);
            } else {
              this.hintText = "短信发送成功";
              this.showHint = true;
              this.setCountDown();
              this.onCodeNum = true;
              this.onCodeText = false;
              // 60秒倒计时
              this.sec = res.data.countdown;
              var auth_timetimer = setInterval(() => {
                this.sec--;
                if (this.sec <= 0) {
                  this.onCodeText = true;
                  this.onCodeNum = false;
                  this.preventClick = false;
                  clearInterval(auth_timetimer);
                }
              }, 1000);
              rs(res);
            }
          })
          .catch(() => {
            rj({});
          });
      });
    },
    // 关闭
    handleClose() {
      this.oftenCode = false;
      this.preventClick = false;
    },
    // 1秒倒计时
    setCountDown() {
      setTimeout(() => {
        this.showHint = false;
      }, 1000);
    },
    // 返回
    // handleBack(){
    //   this.$router.push
    // }
    // 登录
    goLogin() {
      if (this.telNum.trim() == "") {
        this.hintText = "请输入手机号";
        this.showHint = true;
        this.setCountDown();
        return;
      }
      if (this.telCode.trim().length != 6) {
        this.hintText = "请输入6位验证码";
        this.showHint = true;
        this.setCountDown();
        return;
      }
      this.$API
        .goLogin({
          area_code: this.areaCode,
          mobile: this.telNum,
          code: this.telCode,
        })
        .then((res) => {
          if (res.error_code != 0) {
            this.hintText = res.message;
            this.showHint = true;
            this.setCountDown();
          } else {
            localStorage.setItem("contoken", res.data.token);
            // this.getProve();
            this.$router.push({
              path: "/Result",
              query: {
                code: this.qrCode,
                scan_source: this.originCode,
              },
            });
          }
        });
    },
    handleBack() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped lang="scss">
.verify {
  font-family: "PingFang SC";

  .head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: relative;
    h2 {
      font-size: 16px;
      font-weight: 500;
      color: #333436;
      letter-spacing: 0px;
    }
    span {
      position: absolute;
      top: 9px;
      left: 17px;
      font-size: 22px;
      font-weight: 550;
    }
  }
  .bananer {
    width: 100%;
    // height: 211px;
    img {
      width: 100%;
      // height: 100%;
      object-fit: cover;
    }
  }
  .tel {
    padding-top: 36px;
    margin-bottom: 33px;
    .tel_num {
      width: 293px;
      height: 18px;
      margin: 0 auto;
      border-bottom: 1px solid #b3b3b3;
      padding: 7px 0 10px;
      display: flex;
      margin-bottom: 50px;
      padding-right: 8px;
      .right {
        display: flex;
        align-items: center;
        input {
          border: none;
          width: 221px;
          height: 100%;
          caret-color: #07d1aa;
          outline: none;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          color: #333338;
        }
        .clear {
          padding-top: 3px;
          img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .left {
        width: 56px;
        font-size: 14px;
        font-family: "PingFang SC";
        color: #333338;
        span {
          margin-right: 3px;
        }
      }
    }
    .tel_code {
      width: 287px;
      height: 18px;
      margin: 0 auto;
      border-bottom: 1px solid #b3b3b3;
      padding: 7px 7px 10px;
      display: flex;
      justify-content: space-between;
      input {
        border: none;
        width: 100px;
        height: 100%;
        caret-color: #07d1aa;
        outline: none;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        color: #333338;
      }
      div {
        font-size: 14px;
        font-family: "PingFang SC";
        color: #979797;
      }
      &_text {
        color: #07d1aa !important;
      }
    }
  }
  .btn {
    margin: 0 auto 40px;
    width: 316px;
    height: 54px;
    border-radius: 27px;
    line-height: 54px;
    background-color: #c1c2c6;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
  }
  .commit {
    margin: 0 auto 40px;
    width: 316px;
    height: 54px;
    border-radius: 27px;
    line-height: 54px;
    background-color: #07d1aa;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
  }
  .failed {
    width: 100%;
    margin-bottom: 20px;
  }
  .info {
    text-align: left;
    margin: 0 auto;
    width: 326px;
    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #323643;
      margin-bottom: 9px;
    }
    p {
      margin-bottom: 3px;
      font-size: 12px;
      color: #979797;
    }
  }
  .logo {
    margin: 36px auto 16px;
    img {
      width: 111px;
      height: 30px;
    }
  }
  .verify_shade {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 8;
  }
  .content {
    width: 247px;
    height: 154px;
    background: #ffffff;
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 9;
    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #333338;
      margin-top: 7px;
      margin-bottom: 20px;
    }
    &_text {
      font-size: 16px;
      color: #333338;
      margin-bottom: 25px;
    }
    &_btn {
      height: 42px;
      line-height: 42px;
      border-top: 1px solid #ededed;
      font-size: 14px;
      color: #07d1aa;
    }
  }
  .light_hint {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 37px;
    span {
      padding: 9px 30px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
    }
  }
}
//修改placeholder的默认颜色：
input::-webkit-input-placeholder {
  color: #c1c2c6;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c1c2c6;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c1c2c6;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #c1c2c6;
}
.gaodu {
  padding-bottom: 72px;
}
</style>
